// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__b-VXa","list":"Navbar_list__u18pM","item":"Navbar_item__iRtjp"};